export default {
  body: `"Poppins", sans-serif`,
  heading: `"Noto Serif Display", sans-serif`,
}
